var map = {
	"./favicon.ico": 78,
	"./frontend/argentina-gob-ar": 3,
	"./frontend/argentina-gob-ar.svg": 3,
	"./frontend/logo-bicentenario": 4,
	"./frontend/logo-bicentenario.png": 4,
	"./frontend/logo-decreto": 5,
	"./frontend/logo-decreto.png": 5,
	"./frontend/normas-esenciales": 6,
	"./frontend/normas-esenciales.svg": 6,
	"./gba/2019/v2/isologotipo_a_blanco": 7,
	"./gba/2019/v2/isologotipo_a_blanco.svg": 7,
	"./gba/2019/v2/isologotipo_a_positivo": 8,
	"./gba/2019/v2/isologotipo_a_positivo.svg": 8,
	"./gba/2019/v2/isologotipo_a_una_tinta": 9,
	"./gba/2019/v2/isologotipo_a_una_tinta.svg": 9,
	"./gba/2019/v2/isologotipo_b_blanco": 10,
	"./gba/2019/v2/isologotipo_b_blanco.svg": 10,
	"./gba/2019/v2/isologotipo_b_positivo": 11,
	"./gba/2019/v2/isologotipo_b_positivo.svg": 11,
	"./gba/2019/v2/isologotipo_b_una_tinta": 12,
	"./gba/2019/v2/isologotipo_b_una_tinta.svg": 12,
	"./gba/2019/v2/isologotipo_c_blanco": 13,
	"./gba/2019/v2/isologotipo_c_blanco.svg": 13,
	"./gba/2019/v2/isologotipo_c_positivo": 14,
	"./gba/2019/v2/isologotipo_c_positivo.svg": 14,
	"./gba/2019/v2/isologotipo_c_una_tinta": 15,
	"./gba/2019/v2/isologotipo_c_una_tinta.svg": 15,
	"./gba/2019/v2/logotipo_blanco": 16,
	"./gba/2019/v2/logotipo_blanco.svg": 16,
	"./gba/2019/v2/logotipo_positivo": 17,
	"./gba/2019/v2/logotipo_positivo.svg": 17,
	"./gba/2019/v2/sg/sg_a_blanco": 18,
	"./gba/2019/v2/sg/sg_a_blanco.svg": 18,
	"./gba/2019/v2/sg/sg_a_positivo": 19,
	"./gba/2019/v2/sg/sg_a_positivo.svg": 19,
	"./gba/2019/v2/sg/sg_a_una_tinta": 20,
	"./gba/2019/v2/sg/sg_a_una_tinta.svg": 20,
	"./gba/2019/v2/sg/sg_b_blanco": 21,
	"./gba/2019/v2/sg/sg_b_blanco.svg": 21,
	"./gba/2019/v2/sg/sg_b_positivo": 22,
	"./gba/2019/v2/sg/sg_b_positivo.svg": 22,
	"./gba/2019/v2/sg/sg_b_una_tinta": 23,
	"./gba/2019/v2/sg/sg_b_una_tinta.svg": 23,
	"./gba/2019/v2/sg/sg_c_blanco": 24,
	"./gba/2019/v2/sg/sg_c_blanco.svg": 24,
	"./gba/2019/v2/sg/sg_c_positivo": 25,
	"./gba/2019/v2/sg/sg_c_positivo.svg": 25,
	"./gba/2019/v2/sg/sg_c_una_tinta": 26,
	"./gba/2019/v2/sg/sg_c_una_tinta.svg": 26,
	"./icons/footer-icon-contact": 27,
	"./icons/footer-icon-contact-hover": 28,
	"./icons/footer-icon-contact-hover.png": 28,
	"./icons/footer-icon-contact.png": 27,
	"./icons/footer-icon-facebook": 29,
	"./icons/footer-icon-facebook-hover": 30,
	"./icons/footer-icon-facebook-hover.png": 30,
	"./icons/footer-icon-facebook.png": 29,
	"./icons/footer-icon-ig": 31,
	"./icons/footer-icon-ig-hover": 32,
	"./icons/footer-icon-ig-hover.png": 32,
	"./icons/footer-icon-ig.png": 31,
	"./icons/footer-icon-twitter": 33,
	"./icons/footer-icon-twitter-hover": 34,
	"./icons/footer-icon-twitter-hover.png": 34,
	"./icons/footer-icon-twitter.png": 33,
	"./icons/footer-icon-youtube": 35,
	"./icons/footer-icon-youtube-hover": 36,
	"./icons/footer-icon-youtube-hover.png": 36,
	"./icons/footer-icon-youtube.png": 35,
	"./icons/new_codigos_prov": 37,
	"./icons/new_codigos_prov.svg": 37,
	"./icons/new_constitucion_prov": 38,
	"./icons/new_constitucion_prov.svg": 38,
	"./icons/new_ultimas_leyes": 39,
	"./icons/new_ultimas_leyes.svg": 39,
	"./isologotipo_c_positivo": 40,
	"./isologotipo_c_positivo.svg": 40,
	"./logo": 41,
	"./logo-normas-ak-alt": 42,
	"./logo-normas-ak-alt.png": 42,
	"./logo.svg": 41,
	"./logo_dark": 43,
	"./logo_dark.png": 43,
	"./logo_footer": 44,
	"./logo_footer.svg": 44,
	"./logo_normas": 45,
	"./logo_normas.png": 45,
	"./malvinas/Iso_1": 46,
	"./malvinas/Iso_1.svg": 46,
	"./malvinas/Iso_2": 47,
	"./malvinas/Iso_2.svg": 47,
	"./malvinas/Sist_Malvinas_Blanco": 48,
	"./malvinas/Sist_Malvinas_Blanco.orig": 49,
	"./malvinas/Sist_Malvinas_Blanco.orig.svg": 49,
	"./malvinas/Sist_Malvinas_Blanco.svg": 48,
	"./malvinas/Sist_Malvinas_Color": 50,
	"./malvinas/Sist_Malvinas_Color.svg": 50,
	"./malvinas/Sist_Malvinas_Negativo": 51,
	"./malvinas/Sist_Malvinas_Negativo.svg": 51,
	"./malvinas/Sist_Malvinas_Positivo": 52,
	"./malvinas/Sist_Malvinas_Positivo.svg": 52,
	"./malvinas/background": 53,
	"./malvinas/background.svg": 53,
	"./malvinas/iso_ok": 54,
	"./malvinas/iso_ok.orig": 55,
	"./malvinas/iso_ok.orig.svg": 55,
	"./malvinas/iso_ok.svg": 54,
	"./malvinas/iso_ok2": 56,
	"./malvinas/iso_ok2.svg": 56,
	"./malvinas/isologotipo_b_blanco": 57,
	"./malvinas/isologotipo_b_blanco.svg": 57,
	"./normas-ba_icon_128": 58,
	"./normas-ba_icon_128.png": 58,
	"./normas-ba_icon_144": 59,
	"./normas-ba_icon_144.png": 59,
	"./normas-ba_icon_16": 60,
	"./normas-ba_icon_16.png": 60,
	"./normas-ba_icon_24": 61,
	"./normas-ba_icon_24.png": 61,
	"./normas-ba_icon_32": 62,
	"./normas-ba_icon_32.png": 62,
	"./normas-ba_icon_48": 63,
	"./normas-ba_icon_48.png": 63,
	"./normas-ba_icon_512": 64,
	"./normas-ba_icon_512.png": 64,
	"./normas-ba_icon_64": 65,
	"./normas-ba_icon_64.png": 65,
	"./normas-ba_icon_72": 66,
	"./normas-ba_icon_72.png": 66,
	"./normas-ba_icon_96": 67,
	"./normas-ba_icon_96.png": 67,
	"./sindma/SINDMA_web": 68,
	"./sindma/SINDMA_web.png": 68,
	"./sindma/footer-logo-gba": 69,
	"./sindma/footer-logo-gba.jpeg": 69,
	"./sindma/footer-skyline": 70,
	"./sindma/footer-skyline.jpg": 70,
	"./sindma/hero-teclado": 71,
	"./sindma/hero-teclado.png": 71,
	"./sindma/icon-codigos": 72,
	"./sindma/icon-codigos.png": 72,
	"./sindma/icon-constitucion": 73,
	"./sindma/icon-constitucion.png": 73,
	"./sindma/icon-normativa": 74,
	"./sindma/icon-normativa.png": 74,
	"./sindma/icon-ultimasleyes": 75,
	"./sindma/icon-ultimasleyes.png": 75,
	"./sindma/pba-logo": 76,
	"./sindma/pba-logo.png": 76
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;